import { render } from "./icon-reviewed-counter-1.svg?vue&type=template&id=be2c2ebd&scoped=true&component"
const script = {}

import "./icon-reviewed-counter-1.svg?vue&type=style&index=0&id=be2c2ebd&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2c2ebd"]])

export default __exports__